import React from 'react';
import { ReferralForm } from '../components/ReferralForm';
import { ArrowLeftIcon } from 'lucide-react';
interface ReferralPageProps {
  onBack?: () => void;
}
export function ReferralPage({
  onBack
}: ReferralPageProps) {
  return <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 font-sans" data-id="element-73">
      {onBack && <div className="sm:mx-auto sm:w-full sm:max-w-md mb-4" data-id="element-74">
          <button onClick={onBack} className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-900 transition-colors" data-id="element-75">
            <ArrowLeftIcon className="h-4 w-4" data-id="element-76" />
            Back
          </button>
        </div>}

      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-77">
        <div className="flex justify-center" data-id="element-78">
          <img src="https://cdn.magicpatterns.com/uploads/4phTewesRknpwwZMqHaus9/LL_logo.png" alt="Lend-A-Loan" className="h-16 object-contain" data-id="element-79" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 tracking-tight" data-id="element-80">
          Employee Referral
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600 max-w-sm mx-auto" data-id="element-81">
          Know someone great? Refer talent directly to the Lend-A-Loan HR team.
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-82">
        <div className="bg-white py-8 px-4 shadow-xl shadow-gray-200/50 sm:rounded-2xl sm:px-10 border border-gray-100" data-id="element-83">
          <ReferralForm data-id="element-84" />
        </div>
      </div>
    </div>;
}